<template>
    <div class="error-overlay-wrapper">
        <div class="error-message-wrapper" :style="errorMessageWrapperStyle">
            <div class="error-message" :style="errorMessageStyle">{{ title }}</div>
            <div class="error-sub-message">{{message}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ErrorOverlay",
    props:{
        message: String,
        fontScale:{
            type: Number,
            default: 1
        },
        title: String
    },
    computed:{
        errorMessageWrapperStyle(){
            return {
                fontSize: `${2*this.fontScale}rem`
            }
        },
        errorMessageStyle(){
            return {
                fontSize: `${3*this.fontScale}rem`
            }
        }
    }
}
</script>

<style scoped lang="scss">
.error-overlay-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000000d1;
    z-index: 2;
    .error-message-wrapper {
        position: absolute;
        margin: auto 0 auto 0;
        top: 50%;
        transform: translateY(-50%);
        padding: 1rem;
        background: #ffffff4a;
        width: 100%;
        //font-size: 2rem;
        text-align: center;
        .error-message {
            color: #FFC107;
            //font-size: 3rem;
            font-weight: 600;
        }
        .error-sub-message {
            color: white;
        }
    }
}
</style>